module.exports = __webpack_public_path__ + "img/green-house.2872e6b8.jpg";